import React, { useState, useEffect } from 'react'
import { StyleSheet } from 'react-native'
import { NavigationContainer } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import LoginScreen from './screens/LoginScreen'
import MainContainer from './screens/MainContainer'
import OnboardingScreens from './screens/OnboardingScreens'
import { NativeBaseProvider } from 'native-base'
import { RecoilRoot } from 'recoil'
import theme from './utils/theme'
import AsyncStorage from '@react-native-async-storage/async-storage'
import AnimatedSplash from 'react-native-animated-splash-screen'
import { useFonts, Montserrat_100Thin, Montserrat_300Light, Montserrat_400Regular, Montserrat_500Medium, Montserrat_700Bold, Montserrat_900Black } from '@expo-google-fonts/montserrat'
// Disables warning messages
import { LogBox } from 'react-native'
import ForgotPasswordScreen from './screens/ForgotPasswordScreen'
import SignupScreen from './screens/SignupScreen'
import IntroScreen from './screens/IntroScreen'
import Terms from './screens/Legal/Terms'
import Privacy from './screens/Legal/Privacy'
LogBox.ignoreAllLogs()

const Stack = createNativeStackNavigator()

export default function App() {
    const [isLoaded, setIsLoaded] = useState(false)

    setTimeout(() => {
        setIsLoaded(true)
    }, 2000)

    return (
        <AnimatedSplash translucent={true} isLoaded={isLoaded} logoImage={require('./assets/logos/ZHOnly-white.png')} backgroundColor={'#6c387a'} logoHeight={150} logoWidth={150}>
            <RecoilRoot>
                <NativeBaseProvider theme={theme}>
                    <NavigationContainer>
                        <Stack.Navigator>
                            <Stack.Screen options={{ headerShown: false }} name="Intro" component={IntroScreen} />
                            <Stack.Screen options={{ headerShown: false }} name="Signup" component={SignupScreen} />
                            <Stack.Screen options={{ headerShown: true }} name="Terms" component={Terms} />
                            <Stack.Screen options={{ headerShown: true }} name="Privacy" component={Privacy} />
                            <Stack.Screen options={{ headerShown: false }} name="Onboarding" component={OnboardingScreens} />
                            <Stack.Screen options={{ headerShown: false }} name="Login" component={LoginScreen} />
                            <Stack.Screen options={{ headerShown: false }} name="ForgotPassword" component={ForgotPasswordScreen} />
                            <Stack.Screen options={{ headerShown: false }} name="MainContainer" component={MainContainer} />
                        </Stack.Navigator>
                    </NavigationContainer>
                </NativeBaseProvider>
            </RecoilRoot>
        </AnimatedSplash>
    )

    // let [fontsLoaded] = useFonts({
    //     Montserrat_100Thin,
    //     Montserrat_300Light,
    //     Montserrat_400Regular,
    //     Montserrat_500Medium,
    //     Montserrat_700Bold,
    //     Montserrat_900Black,
    // })

    // if (!fontsLoaded) {
    //     return <></>
    // }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
})
